import _createClass from "@babel/runtime/helpers/createClass";
import _inheritsLoose from "@babel/runtime/helpers/inheritsLoose";
import RelationalField from "./RelationalField";
import { forwardsManyToOneDescriptor, backwardsManyToOneDescriptor } from "../descriptors";
/**
 * @memberof module:fields
 */

export var ForeignKey =
/*#__PURE__*/
function (_RelationalField) {
  _inheritsLoose(ForeignKey, _RelationalField);

  function ForeignKey() {
    return _RelationalField.apply(this, arguments) || this;
  }

  var _proto = ForeignKey.prototype;

  _proto.createForwardsDescriptor = function createForwardsDescriptor(fieldName, model, toModel, throughModel) {
    return forwardsManyToOneDescriptor(fieldName, toModel.modelName);
  };

  _proto.createBackwardsDescriptor = function createBackwardsDescriptor(fieldName, model, toModel, throughModel) {
    return backwardsManyToOneDescriptor(fieldName, model.modelName);
  };

  _createClass(ForeignKey, [{
    key: "index",
    get: function get() {
      return true;
    }
  }]);

  return ForeignKey;
}(RelationalField);
export default ForeignKey;